import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import * as FlatServices from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-page-link-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './page-link-dialog.component.html',
    styleUrls: ['./page-link-dialog.component.scss'],
    standalone: false
})
export class PageLinkDialogComponent {
  nodeIds: string[] = [];
  readonly FlatModels = FlatModels;

  constructor(public appSharedFacade: FlatFacades.AppSharedFacade,
              public bulkEditAuthorFacade: FlatFacades.BulkEditAuthorFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade,
              public mediaControlService: FlatServices.MediaControlService,
              public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig,) {
  }
  
  pageTrackBy(index: number,
              item: FlatModels.PageEntityModels.PageEntityType){
    return item.id || index;
  }
  
  onSwitchChange(routeElement: FlatModels.NodeEntityModels.RouteElement,
                 event: any) {
    if (event.checked) {
      this.nodeSharedFacade.requestNodesByParentId(routeElement.id);
      this.nodeIds.push(routeElement.id);
    } else {
      this.nodeIds.splice(this.nodeIds.findIndex((v: string) => v === routeElement.id), 1);
    }
  }
  
  isInArray(routeElement: FlatModels.NodeEntityModels.RouteElement) {
    return this.nodeIds.findIndex((v: string) => v === routeElement.id) > -1;
  }
}
